<template>
  <div id="ms_header_downside" class="parent_div">
    <dd-header />
    <div class="wrapper">
      <div class="main_content">
        <dd-menu ref="menuRef"/>
        <div id="signup">
          <dd-sitemap
            :pageKey="pageKey"
            :pageList="pageList"
            :mapStyle="'topic_path'"
          />
          <section id="singin_form">
            <div>ログイン</div>
            <div>
              <dd-login />
            </div>
          </section>
          <!-- <section>
            <h2>会員登録するとこんなに便利！</h2>
            <ul class="ul_user_register">
              <li>
                <h3>①会員限定価格での商品購入</h3>
                <p>ここに説明文が入ります。</p>
              </li>
              <li>
                <h3>②メールマガジンでお得な情報をお届け</h3>
                <p>ここに説明文が入ります。</p>
              </li>
              <li>
                <h3>③カスタマイズ情報の保存</h3>
                <p>ここに説明文が入ります。</p>
              </li>
              <li>
                <h3>④ご注文時の情報入力がスムーズに</h3>
                <p>ここに説明文が入ります。</p>
              </li>
            </ul>
          </section>
          <section>
            <h2>法人会員様は更に便利！</h2>
            <p>
              法人・個人事業主様の場合、前述のメリットに加えて以下の特典がございます。（法人会員の発行には所定の審査がございます。）
            </p>
            <ul class="ul_user_register">
              <li>
                <h3>① 法人会員限定価格での商品購入</h3>
                <p>ここに説明文が入ります。</p>
              </li>
              <li>
                <h3>② 掛け払いの利用申請が可能</h3>
                <p>ここに説明文が入ります。</p>
              </li>
              <li>
                <h3>③ オーダー家具営業ノウハウのご提供</h3>
                <p>ここに説明文が入ります。</p>
              </li>
            </ul>
          </section> -->
        </div>
      </div>
    </div>
    <dd-footer />
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
  </div>
</template>
<script>
import * as App from '../../utils/App'

import DcHeader from '../components/common/DcHeader'
import Footer from '../components/common/DcFooter'
import DDLeftMenu from '../components/top/DcLeftMenu'
import DcSiteMap from '../components/common/DcSiteMap'
import LoadingModal from '../../components/common/LoadingModal'
import LoginForm from '../components/login/DcLoginForm'

export default {
  components: {
    'dd-header': DcHeader,
    'dd-footer': Footer,
    'dd-login': LoginForm,
    'dd-menu': DDLeftMenu,
    'dd-sitemap': DcSiteMap,
    'dd-loading-modal': LoadingModal
  },
  data () {
    return {
      pageKey: 'dcSignIn',
      pageList: [
        {id: 'top', key: 'dcTop', title: 'トップページ', route: 'DcTop'},
        {id: 'signin', key: 'dcSignIn', title: 'ログイン', route: 'DcSignIn'}
      ]
    }
  },
  computed: {
  },
  methods: {
    getImage: function (image) {
      return App.getMmstyleResource(image)
    }
  },
  created: function () {
  }
}
</script>
<style src="../css/dc-mainmenu.scss" lang="scss" scoped></style>
<style src="../css/dctop4.scss" lang="scss" scoped></style>
<style src="../css/dc-login.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/DcSignIn.vue